import "./style/index.scss";
import * as Icon from "@ant-design/icons";
import { Button, Col, Flex, Form, Input, Row, Select, Space, Table, Tooltip, Typography, Upload, UploadFile, UploadProps } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import React, { useEffect, useState } from "react";
import { setDataSourceAnexo, setEditingKeyAnexo, setModalArquivo } from "../../redux/slices/arquivoAnexo/arquivoAnexoSlice";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import { ArquivoAnexoJsonModel } from "../../models/arquivoAnexo/arquivoAnexoJsonModel";
import { ArquivoAnexoModel } from "../../models/arquivoAnexo/arquivoAnexoModel";
import { cadastrarArquivoAnexo } from "../../services/arquivoAnexoService";
import { AnexoItemModel } from "../../models/arquivoAnexo/anexoItemModel";
import { toastWarning } from "../../util/toast";
import * as PhosphorIcon from "phosphor-react";
import { TipoArquivoAnexoModel } from "../../models/arquivoAnexo/tipoArquivoAnexoModel";

dayjs.locale("pt-br");

const { Text } = Typography;
interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType: "image" | "select" | "string";
  record: AnexoItemModel;
  index: number;
  children: React.ReactNode;
}

type UploadArquivosComponentProps = {
  idOrigem: number;
  container: string;
  visualizar?: boolean;
  contaCadastro?: boolean;
  origem: string;
};

const UploadArquivosComponent = ({ idOrigem, container, visualizar = false, contaCadastro = false, origem = "" }: UploadArquivosComponentProps) => {
  //estados globais
  const arquivoAnexoState = useAppSelector((state) => state.arquivoAnexo);
  const contaFinanceiraState = useAppSelector((state) => state.contaFinanceira);
  const lancamentoBancarioState = useAppSelector((state) => state.lancamentoBancario);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [formManual] = Form.useForm();
  const [count, setCount] = useState<number>(0);
  const [isEmpty, setIsEmpty] = useState(false);

  useEffect(() => {
    if (arquivoAnexoState.dataSourceAnexo.length !== 0) {
      setCount(arquivoAnexoState.dataSourceAnexo.length);
    }
  }, [arquivoAnexoState.dataSourceAnexo]);

  //retorna string de base64 para ser enviada para API
  const toBase64 = (img: any, callback: any) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleImageChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
    if (newFileList.length === 0) {
      formManual.setFieldValue("arquivo", undefined);
      setIsEmpty(true);
    } else {
      if (newFileList[0] !== undefined) {
        formManual.setFieldValue("caminhoArquivo", newFileList[0].originFileObj);

        // toBase64(newFileList[0].originFileObj, (imageUrlResponse: any) => {
        //   formManual.setFieldValue("caminhoArquivo", imageUrlResponse);
        // });
      }
      var arquivo = {
        uid: "-1",
        name: newFileList[0].name,
        status: "done",
        type: newFileList[0].type,
        url: formManual.getFieldValue("caminhoArquivo"),
      };
      formManual.setFieldValue("arquivo", arquivo);
      setIsEmpty(false);
    }
  };

  const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
    const inputNode =
      inputType === "image" ? (
        <Upload
          defaultFileList={formManual.getFieldValue("arquivo") !== undefined ? [formManual.getFieldValue("arquivo")] : []}
          action={"dummyRequest"}
          onChange={handleImageChange}
          beforeUpload={() => {
            return false;
          }}
        >
          {formManual.getFieldValue("arquivo") === undefined || isEmpty ? <Button icon={<Icon.UploadOutlined />}>anexar</Button> : <></>}
        </Upload>
      ) : inputType === "select" ? (
        <Select
          autoFocus
          showSearch
          style={{ width: 180 }}
          optionFilterProp="label"
          loading={arquivoAnexoState.loadingTipo}
          options={arquivoAnexoState.listTipo.map((a: TipoArquivoAnexoModel) => ({
            value: a.id,
            label: a.denominacao,
          }))}
        />
      ) : (
        <Input type="text" style={{ width: 300 }} />
      );

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `Informe o ${title}`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const isEditing = (record: AnexoItemModel) => record.key === arquivoAnexoState.editingKeyAnexo;

  const edit = (record: Partial<AnexoItemModel> & { key: React.Key }) => {
    formManual.setFieldsValue({
      arquivo: record.arquivo,
      idTipoArquivoAnexo: record.idTipoArquivoAnexo,
      observacao: record.observacao,
    });
    dispatch(setEditingKeyAnexo(record.key));
  };

  const handleDelete = (key: React.Key) => {
    const newData = arquivoAnexoState.dataSourceAnexo.filter((item: any) => item.key !== key);
    setCount(count - 1);
    dispatch(setDataSourceAnexo(newData));
  };

  const cancel = (key: React.Key) => {
    const hasData = arquivoAnexoState.dataSourceAnexo.find((item: any) => item.key === key);
    if (hasData?.observacao === null) {
      handleDelete(key);
    }
    dispatch(setEditingKeyAnexo(""));
  };

  const handleAdd = () => {
    if (arquivoAnexoState.editingKeyAnexo === "") {
      var contadorSoma = count + 1;
      const newData: AnexoItemModel = {
        key: contadorSoma.toString(),
        arquivo: {} as UploadFile,
        caminhoArquivo: null,
        idTipoArquivoAnexo: null,
        observacao: null,
      };
      dispatch(setDataSourceAnexo([...arquivoAnexoState.dataSourceAnexo, newData]));
      dispatch(setEditingKeyAnexo(contadorSoma.toString()));
      setCount(contadorSoma);
      formManual.resetFields();
    } else {
      toastWarning("Para adicionar uma novo item, salve primeiro o item que já está em edição.");
    }
  };

  const save = async (key: React.Key, abrir: boolean) => {
    try {
      const row = (await formManual.validateFields()) as AnexoItemModel;
      const newData = [...arquivoAnexoState.dataSourceAnexo];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
          caminhoArquivo: formManual.getFieldValue("caminhoArquivo"),
        });
        dispatch(setDataSourceAnexo(newData));
        if (abrir) {
          const newData: AnexoItemModel = {
            key: count.toString(),
            arquivo: {} as UploadFile,
            caminhoArquivo: null,
            idTipoArquivoAnexo: null,
            observacao: null,
          };
          dispatch(setDataSourceAnexo([...arquivoAnexoState.dataSourceAnexo, newData]));
          dispatch(setEditingKeyAnexo(count.toString()));
          setCount(count + 1);
          formManual.resetFields();
        }
      } else {
        newData.push(row);
        dispatch(setDataSourceAnexo(newData));
        if (abrir) {
          const newData: AnexoItemModel = {
            key: count.toString(),
            arquivo: {} as UploadFile,
            caminhoArquivo: null,
            idTipoArquivoAnexo: null,
            observacao: null,
          };
          dispatch(setDataSourceAnexo([...arquivoAnexoState.dataSourceAnexo, newData]));
          dispatch(setEditingKeyAnexo(count.toString()));
          setCount(count + 1);
          formManual.resetFields();
        }
      }
      dispatch(setEditingKeyAnexo(""));
    } catch (e) {}
  };

  const columns = [
    {
      title: "Nome do anexo",
      dataIndex: "arquivo",
      editable: true,
      render: (arquivo: UploadFile) => {
        return (
          <>
            <Upload defaultFileList={[arquivo]} showUploadList={{ showRemoveIcon: false }}></Upload>
          </>
        );
      },
    },
    {
      title: "Tipo de anexo",
      dataIndex: "idTipoArquivoAnexo",
      editable: true,
      render: (idTipoArquivoAnexo: number) => {
        var denominacao;
        idTipoArquivoAnexo !== 0
          ? (denominacao = arquivoAnexoState.listTipo.find((a: TipoArquivoAnexoModel) => a.id === idTipoArquivoAnexo)?.denominacao)
          : (denominacao = "selecione uma conta financeira");
        return <>{denominacao}</>;
      },
    },
    {
      title: "Descrição",
      dataIndex: "observacao",
      editable: true,
      align: "right" as "right",
    },
    {
      title: "Ação",
      render: (_: any, record: AnexoItemModel) => {
        const editable = isEditing(record);
        return editable ? (
          <Flex justify="center" align="center" gap={4}>
            <Tooltip title="Salvar">
              <PhosphorIcon.CheckCircle style={{ cursor: "pointer" }} size={20} color="#334155" onClick={() => save(record.key, false)} />
            </Tooltip>
            <Tooltip title="Cancelar">
              <PhosphorIcon.XCircle style={{ cursor: "pointer" }} size={20} color="#334155" onClick={() => cancel(record.key)} />
            </Tooltip>
          </Flex>
        ) : (
          <Flex justify="center" gap={4}>
            <Tooltip title="Editar">
              <PhosphorIcon.Pencil style={{ cursor: "pointer" }} size={20} color="#334155" onClick={() => edit(record)} />
            </Tooltip>
            <Tooltip title="Remover">
              <PhosphorIcon.Trash style={{ cursor: "pointer" }} size={20} color="#334155" onClick={() => handleDelete(record.key)} />
            </Tooltip>
          </Flex>
        );
      },
    },
  ];

  const columnsSemAcao = [
    {
      title: "Nome do anexo",
      dataIndex: "arquivo",
      editable: true,
      render: (arquivo: UploadFile) => <Upload defaultFileList={[arquivo]} showUploadList={{ showRemoveIcon: false }}></Upload>,
    },
    {
      title: "Tipo de anexo",
      dataIndex: "idTipoArquivoAnexo",
      editable: true,
      render: (idTipoArquivoAnexo: number) => {
        var denominacao;
        idTipoArquivoAnexo !== 0
          ? (denominacao = arquivoAnexoState.listTipo.find((a: TipoArquivoAnexoModel) => a.id === idTipoArquivoAnexo)?.denominacao)
          : (denominacao = "selecione uma conta financeira");
        return <>{denominacao}</>;
      },
    },
    {
      title: "Descrição",
      dataIndex: "observacao",
      editable: true,
      align: "right" as "right",
    },
  ];

  const mergedColumns = visualizar
    ? columnsSemAcao.map((col) => {
        if (!col.editable) {
          return col;
        }
        return {
          ...col,
          onCell: (record: AnexoItemModel) => ({
            record,
            inputType: col.dataIndex === "arquivo" ? "image" : col.dataIndex === "idTipoArquivoAnexo" ? "select" : "string",
            dataIndex: col.dataIndex,
            title: col.title,
            editing: isEditing(record),
          }),
        };
      })
    : columns.map((col) => {
        if (!col.editable) {
          return col;
        }
        return {
          ...col,
          onCell: (record: AnexoItemModel) => ({
            record,
            inputType: col.dataIndex === "arquivo" ? "image" : col.dataIndex === "idTipoArquivoAnexo" ? "select" : "string",
            dataIndex: col.dataIndex,
            title: col.title,
            editing: isEditing(record),
          }),
        };
      });

  const submit = () => {
    var arquivoJson: ArquivoAnexoJsonModel[] = [];
    arquivoAnexoState.dataSourceAnexo.forEach((v: any) => {
      var detalhes = {
        caminhoArquivo: v.caminhoArquivo,
        extensaoArquivo: v.arquivo.type,
        idTipoArquivoAnexo: v.idTipoArquivoAnexo,
        observacao: v.observacao,
        nome: v.arquivo.name,
      };
      arquivoJson.push(detalhes);
    });
    var arquivo: ArquivoAnexoModel = {
      id: null,
      idOrigem: idOrigem,
      caminhoArquivo: null,
      extensaoArquivo: null,
      idTipoArquivoAnexo: null,
      observacao: null,
      nome: null,
      arquivoAnexo: arquivoJson,
      containerName: container,
      dataCriacao: null,
      idUsuario: null,
    };
    if (arquivoAnexoState.editingKeyAnexo === "") {
      if (origem === "contaFinanceira" && !contaCadastro) {
        dispatch(cadastrarArquivoAnexo({ value: arquivo, busca: contaFinanceiraState.busca, origem: "contaFinanceira" }));
      }
      if (origem === "lancamento") {
        dispatch(cadastrarArquivoAnexo({ value: arquivo, busca: lancamentoBancarioState.busca, origem: "lancamentoBancario" }));
      }
    } else {
      toastWarning("Finalize a edição do item antes de salvar");
    }
  };

  const voltar = () => {
    dispatch(setModalArquivo(false));
  };

  return (
    <Flex vertical>
      <Row gutter={12}>
        {!visualizar && (
          <Col span={2}>
            <Button onClick={handleAdd} type="primary" style={{ marginBottom: 24 }} icon={<Icon.PlusCircleOutlined />}>
              Adicionar
            </Button>
          </Col>
        )}
      </Row>

      {!(visualizar || contaCadastro) && (
        <Flex style={{ marginBottom: 16 }} gap={4} align="center">
          <PhosphorIcon.Info color="#334155" />
          <Text style={{ fontSize: 14, fontFamily: "'Inter', sans-serif", color: "#334155" }}>Ao editar uma conta financeira, não é necessário atualizar a conta para salvar o anexo.</Text>
        </Flex>
      )}
      <Form form={formManual} component={false}>
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item>
              <Table
                size="small"
                components={{
                  body: {
                    cell: EditableCell,
                  },
                }}
                rowKey="id"
                rowClassName="editable-row"
                dataSource={arquivoAnexoState.dataSourceAnexo}
                columns={mergedColumns}
                pagination={false}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<Icon.CloseOutlined />}>
              FECHAR
            </Button>
            {!(visualizar || contaCadastro) && (
              <Button onClick={submit} icon={<Icon.CheckOutlined />} className="buttonPrimary">
                SALVAR
              </Button>
            )}
          </Space>
        </Col>
      </Row>
    </Flex>
  );
};

export default UploadArquivosComponent;
